// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1cbPb","productName":"Table_productName__25NyW"};